import React, { useEffect, useRef, useState } from 'react';

import { faArrowLeft, faChevronDown, faGear, faPlus, faChevronUp, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ApexCharts from 'react-apexcharts';
import { Button, Col, Dropdown, Form, Modal, Row, Table, InputGroup, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import edit from "../../../../assets/images/edit.png";
import Trash from '../../../../assets/images/trash.png';
import View from '../../../../assets/images/show.png';
import Popup from 'reactjs-popup';
import { withRFSToken } from '../../../../Services/axios.js';
import { TRUCKPLANNINGLIST, PALLETLIST, OTRUCKSAVE, OTRUCKDETAIL, OTRUCKREMOVE, OTRUCKASSIGN, TRUCKORDERDETAILS } from '../../../../Utils/conts';
import { toast } from 'react-toastify';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const TruckPlanning = () => {

  const [temperature, setTemperature] = useState(0);
  // const handleIncrease = () => setTemperature(prev => prev + 1);
  // const handleDecrease = () => setTemperature(prev => prev - 1);
  const [palletList, setPalletList] = useState([
    {
      "pallet_group_id": 59,
      "pallet_group_name": "Palletgroup Name 1",
      "position": 4,
      "build_up": "Yes",
      "deck_type": "Upper Deck",
      "uld_type": "AA2",
      "no_pallet": 4,
      "max_height": 1000,
      "pieces": 50,
      "volume": 41.35,
      "weight": 50,
      "shc": "XPS,TRK,GEN,NAS,ECC,EAP,HEA,SPX,SMR,RPN,RAC,TRU,VUN,CGO",
      "min_ct": "2112:52",
      "max_ct": "2112:52",
      "capacity_utilization": 1033,
      "available_valume": 4,
      "operational_truck_list": [
        {
          "truck_orders_id": 120,
          "truck_no": "Operational Truck 1",
          "value": 120,
          "label": "Operational Truck 1"
        }
      ],
      "truck_no": null,
      "truck_orders_id": null,
      "bookingtruck_id": 4279,
      "bookingtruck_date_id": 389082,
      "remarks": "Remarks Remarks Remarks Remarks"
    }
  ]);


  let storedData = localStorage.getItem('BTDetails');
  if (storedData) {
    storedData = JSON.parse(storedData)
  }
  const [selectedRowData, setSelectedRowData] = useState(JSON.parse(localStorage.getItem('BTDetails')));
  const [statusSeries, setStatusSeries] = useState([
    {
      name: 'Units Sold',
      data: [], // [36, 20, 16, 8,]
    },
  ]);

  const [confirmModal, setConfirmModal] = useState(false);
  const confirmModalClose = () => {
    setConfirmModal(false);
  }
  const [statusOptions, setStatusOptions] = useState({
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false // This will hide the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 4,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
        distributed: true,
        dataLabels: {
          position: 'center', // top, center, bottom
        },
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: 0,
      formatter: (val) => {
        return `${val}%`;
      },
      style: {
        fontSize: '12px',
        colors: ["#304758"]
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: [
        ['2C9101M-A'],
        ['2C9101M-B'],

      ],
    },
    yaxis: {
      title: {
        text: ' '
      },
      tickAmount: 4,
      min: 0,
      max: 100,
      labels: {
        formatter: function (val) {
          return Math.floor(val);
        }
      }
    },
    fill: {
      opacity: 1,
      colors: [

        "rgba(255, 85, 34, 1)",
        "rgba(255, 182, 63, 1)",

      ]
    },
    legend: {
      show: false
    },
    colors: ['#d6d6d6', '#ff5522', '#ffb63f', '#20a749'],
    tooltip: {
      y: {
        formatter: function (val) {
          return val + "%";
        }
      }
    }
  });


  const isMounted = useRef(false);
  const [filterApplied, setFilterApplied] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [gridSelect, setGridSelect] = useState([]);
  const gridRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [truckData, setTruckData] = useState(null);
  const [truckList, setTruckList] = useState(null);

  const [formData, setFormData] = useState({
    operational_truck_no: '', departure_date: selectedRowData.departure_date, departure_time: storedData.departure_time
  })

  const fetchTruckData = async (id) => {
    try {

      const res = await withRFSToken.post(TRUCKPLANNINGLIST, { bookingtruck_date_id: selectedRowData.bookingtruck_date_id })
        .then(function (res) {
          const innerData = res.data.response_data;
          const innerDataCal = res.data.response_data.operational_truck_list;
          setTruckData(innerData);
          // setPalletList(innerData);
          const statusLabel = innerDataCal ? innerDataCal.map((item) => item.truck_no) : [];
          const statusData = innerDataCal ? innerDataCal.map((item) => item.total_capacity_utilization) : [];
          setStatusOptions(prevOptions => ({
            ...prevOptions,
            xaxis: {
              ...prevOptions.xaxis,
              categories: statusLabel
            }
          }));
          const condsData = statusData.map((value, index) => ({
            x: statusLabel[index],
            y: value,
            // fillColor: colors[index % colors.length]
            fillColor:
              value < 50 ? '#FF6363' : // Red
                value < 75 ? '#FF9D51' : // Orange
                  '#85DB7B'    // Green
          }));
          setStatusSeries([{
            name: "Capacity Utilization",
            data: condsData
          }]);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleIncrease = (key, defaultMaxValue) => {
    setFormData((prev) => {
      let newState = { ...prev };
      let currentValue = parseFloat(prev[key]);
      if (isNaN(currentValue)) currentValue = 0;

      if (key.endsWith('_start')) {
        // Increase the start value.
        const newStart = Math.min(currentValue + 1, defaultMaxValue);
        newState[key] = newStart;
        const endKey = key.replace('_start', '_end');
        let currentEnd = parseFloat(prev[endKey]);
        if (isNaN(currentEnd)) currentEnd = 0;
        // If the new start exceeds the current end, sync end to new start.
        if (newStart > currentEnd) {
          newState[endKey] = newStart;
        }
      } else {
        // Increase the end value.
        const newEnd = Math.min(currentValue + 1, defaultMaxValue);
        newState[key] = newEnd;
        const startKey = key.replace('_end', '_start');
        let currentStart = parseFloat(prev[startKey]);
        if (isNaN(currentStart)) currentStart = 0;
        // If the new end is less than the current start, sync start to new end.
        if (newEnd < currentStart) {
          newState[startKey] = newEnd;
        }
      }
      return newState;
    });
  };

  const handleDecrease = (key, defaultMinValue) => {
    setFormData((prev) => {
      let newState = { ...prev };
      let currentValue = parseFloat(prev[key]);
      if (isNaN(currentValue)) currentValue = 0;

      if (key.endsWith('_start')) {
        // Decrease the start value.
        const newStart = Math.max(currentValue - 1, defaultMinValue);
        newState[key] = newStart;
        const endKey = key.replace('_start', '_end');
        let currentEnd = parseFloat(prev[endKey]);
        if (isNaN(currentEnd)) currentEnd = 0;
        // If the new start exceeds the current end, sync end to new start.
        if (newStart > currentEnd) {
          newState[endKey] = newStart;
        }
      } else {
        // Decrease the end value.
        const newEnd = Math.max(currentValue - 1, defaultMinValue);
        newState[key] = newEnd;
        const startKey = key.replace('_end', '_start');
        let currentStart = parseFloat(prev[startKey]);
        if (isNaN(currentStart)) currentStart = 0;
        // If the new end is less than the current start, sync start to new end.
        if (newEnd < currentStart) {
          newState[startKey] = newEnd;
        }
      }
      return newState;
    });
  };


  const tempChange = (key, e) => {
    const inputValue = e.target.value;
    const numericValue = parseFloat(inputValue);
    const group = key.split('_')[0]; // e.g., "temp1" or "temp2"

    setFormData((prev) => {
      let newState = { ...prev };

      // Only reinitialize the specific group's values if we're updating a _start field
      // and the current start value is not valid (e.g. undefined or not a number).
      if (
        !key.endsWith('_end') &&
        (prev[`${group}_start`] === undefined || isNaN(parseFloat(prev[`${group}_start`])))
      ) {
        newState = { ...prev, [`${group}_start`]: 0, [`${group}_end`]: 0 };
      }

      if (!isNaN(numericValue)) {
        if (key.endsWith('_end')) {
          const startKey = key.replace('_end', '_start');
          // Clamp the end value: it cannot be lower than its corresponding start, and it cannot exceed 30.
          const newEnd = Math.max(parseFloat(newState[startKey]), Math.min(numericValue, 30));
          newState[key] = newEnd;
          // If the new end is lower than the current start (if that happens), sync the start to match.
          if (newEnd < parseFloat(newState[startKey])) {
            newState[startKey] = newEnd;
          }
        } else {
          // For a start field, clamp between 0 and 30.
          const newStart = Math.max(0, Math.min(numericValue, 30));
          newState[key] = newStart;
          const endKey = key.replace('_start', '_end');
          // If the new start exceeds the current end, update the end to match.
          if (parseFloat(newState[endKey]) < newStart) {
            newState[endKey] = newStart;
          }
        }
      } else {
        // If the input is invalid, reset:
        newState[key] = key.endsWith('_end')
          ? newState[key.replace('_end', '_start')]
          : 0;
      }
      return newState;
    });
  };


  const [show, setShow] = useState(false);
  const [modalMode, setModalMode] = useState(null);
  const handleClose = () => {
    setShow(false);
    setFormData({})
  };

  const handleShow = (e) => {
    setModalMode(e); setShow(true);
    setFormData({
      arrival_date_time: storedData.arrival_date_time, departure_date_time: storedData.departure_date_time
    })
  };

  useEffect(() => {
    // Call the fetchData function to fetch data from the API
    if (isMounted.current) return;
    fetchTruckData(storedData.bookingtruck_date_id);
    // fetchPalletList();
    setIsLoading(false);
    setGridData([]);
    isMounted.current = true;
  }, []);

  const [dropChange, setDropChange] = useState();

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRef.current) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      const source = {
        datatype: 'json',
        datafields: [
          // { name: 'id', type: 'string' },
          { name: 'pallet_group_id', type: 'string' },
          { name: 'pallet_group_name', type: 'string' },
          { name: 'position', type: 'string' },
          { name: 'operational_truck_list', type: 'string' },
          { name: 'truck_no', type: 'string' },
          { name: 'min_ct', type: 'string' },
          { name: 'max_ct', type: 'string' },
          { name: 'shc', type: 'string' },
          { name: 'build_up', type: 'string' },
          { name: 'no_pallet', type: 'string' },
          { name: 'deck_type', type: 'string' },
          { name: 'uld_type', type: 'string' },
          { name: 'max_height', type: 'string' },
          { name: 'truck_orders_id', type: 'string' },
          { name: 'operational_truck_list', type: 'string' },
        ],
        // localData: gridData,
        // id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}awb-planning/pallet-group-list?bookingtruck_id=${storedData.bookingtruck_id}&bookingtruck_date_id=${storedData.bookingtruck_date_id}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 20,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


          setTimeout(() => {
            const rows = window.$(gridRef.current).jqxGrid('getrows');

            console.log("rows", rows);
            (checkUlds).forEach(uldNumber => {
              console.log(checkUlds);
              rows.forEach((element, index) => {
                if (element.uld_number == uldNumber) {
                  window.$(gridRef.current).jqxGrid('selectrow', index);
                }
              });
            });
          }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          if (data && data.response_data && data.response_data.pallet_groups) {
            source.totalrecords = data.TotalRows;
            // Modify the data format for the grid
            data.response_details = data.response_data.pallet_groups;
          }
          // setTotalRows({ totalUlds: data.activeCount });
          // setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "response_details",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      let isEditorOpened = false;
      const columns = [
        {
          text: 'Palletgroup Name', filtertype: 'textbox', datafield: 'pallet_group_name', width: '20%', editable: false,
          cellclassname: (row, column, value, rowData) => {
            // // console.log("🚀 ~ useEffect ~ rowData:", rowData)
            if (rowData.truck_orders_id !== null) {
              return "awb_green";
            } else {
              return "awb_red";
            }
          },
        },
        { text: '#Pos', filtertype: 'textbox', datafield: 'position', width: '4%', cellclassname: '', editable: false },
        {
          text: 'Trucks', filtertype: 'textbox', datafield: 'truck_no',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            if (rowdata.truck_no === null) {
              return '<div class="jqx-grid-cell-left-align set_dock ">Please Select</div>';
            }
          },
          columntype: 'dropdownlist',  // Set column type as dropdownlist
          createeditor: function (row, cellvalue, editor) {
            // Initialize the dropdown editor
            const rowData = window.$(gridRef.current).jqxGrid('getrowdata', row);
            let palletGroups = rowData.operational_truck_list || [];
            palletGroups = [{ label: 'Please Select', value: null }, ...palletGroups];
            // const palletGroups = rowData.pallet_groups || [];
            editor.jqxDropDownList({
              source: palletGroups.map(item => ({ label: item.label, value: item.value })),
              autoDropDownHeight: true,
              displayMember: 'label',
              valueMember: 'value',
              placeHolder: 'Please select',
            });
            let previousValue = cellvalue;
            // let isFirstChange = true;
            isEditorOpened = false;
            editor.on('change', (event) => {
              const selectedItem = event.args.item;
              // console.log("🚀 ~ editor.on ~ selectedItem:", isEditorOpened)

              if (selectedItem && isEditorOpened) {
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', row);
                const newValue = selectedItem.label;
                // if (newValue !== previousValue) {
                rowData.truck_no = selectedItem.label;  // Update row data with label
                rowData.truck_orders_id = selectedItem.value;
                window.$(gridRef.current).jqxGrid('updaterow', row, rowData);
                // handlePalletGroupChange(rowData); // Call your function here
                setDropChange(rowData)
                // previousValue = newValue;
                // isFirstChange = false;
                // }
              }
            });
          },
          initeditor: function (row, cellvalue, editor) {
            // Set the initial value
            // const selected = palletGroups.find(item => item.value === cellvalue);
            // editor.jqxDropDownList('selectItem', selected?.label || null);

            editor.jqxDropDownList('selectItem', cellvalue);
            // Open the dropdown immediately
            editor.jqxDropDownList('open');
            isEditorOpened = true;
          },
          geteditorvalue: function (row, cellvalue, editor) {
            // Return the selected value
            // return editor.jqxDropDownList('getSelectedItem').value;
            const selectedValue = editor.jqxDropDownList('getSelectedItem');
            return selectedValue ? selectedValue.label : null;
          },
          width: '10%', cellclassname: 'raarrow', editable: true
        },
        { text: 'Min.CT', filtertype: 'textbox', datafield: 'min_ct', width: '8%', cellclassname: '', editable: false },
        { text: 'Max.CT', filtertype: 'textbox', datafield: 'max_ct', width: '8%', cellclassname: '', editable: false },
        { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '10%', cellclassname: '', editable: false },
        { text: 'Build Up', filtertype: 'textbox', datafield: 'build_up', width: '5%', cellclassname: '', editable: false },
        { text: '#Pal', filtertype: 'textbox', datafield: 'no_pallet', width: '5%', cellclassname: '', editable: false },
        // { text: 'ULD', filtertype: 'textbox', datafield: 'deck_type', width: '5%', cellclassname: '', editable: false },
        { text: 'ULD Type', filtertype: 'textbox', datafield: 'uld_type', width: '8%', cellclassname: '', editable: false },
        { text: 'Height', filtertype: 'textbox', datafield: 'max_height', width: '8%', cellclassname: '', editable: false },

      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 400,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: true,
        selectionmode: 'checkbox',
        pageable: true,
        // pageSize: 20,
        // pagesizeoptions: ['20', '50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
      };
      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRef.current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const dataToSend = {
          uld_number: rowData.uld_number,
          type_code: rowData.type_code,
          serial_number: rowData.serial_number,
          owner_code: rowData.owner_code,
          condition_code: rowData.condition_code,
          asset_type: rowData.asset_type == 'Y' ? false : true
        };
        // setEditData(dataToSend);
        // setShowEdit(true);
      });
      window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRef.current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.pallet_group_id;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }

          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.pallet_group_id === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRef.current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRef.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.pallet_group_id;
          setGridSelect(prevSelection => prevSelection.filter(row => row.pallet_group_id !== unselectedRowId));

          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
        }
      });
    }
  }, [gridData]);

  useEffect(() => {
    if (dropChange) {
      console.log('dropChange', dropChange);

      handlePalletGroupChange(dropChange)
    }
  }, [dropChange])

  const handlePalletGroupChange = async (newValue) => {
    // Your logic here 
    // console.log("Selected Pallet Group:", newValue);
    // console.log("Selected Pallet Group:gridSelect", gridSelect);
    let awbIds = [];
    if (gridSelect.length > 0) {
      awbIds = gridSelect && gridSelect.map(row => row.pallet_group_id);
    } else {
      awbIds = [newValue?.pallet_group_id];
    }
    console.log("🚀 ~ handlePalletGroupChange ~ ids:", awbIds)
    try {
      const res = await withRFSToken.post(OTRUCKASSIGN, { truck_orders_id: newValue?.truck_orders_id, pallet_group_ids: awbIds })
        .then(function (res) {
          const innerData = res.data.response_data;
          if (res.data.response_code === 200) {
            toast.success(res.data.response_msg);
            fetchTruckData();
            setIsLoading(false);
            setGridData([]);
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
            setGridSelect([]);
          } else {
            toast.error(res.data.response_msg);
            fetchTruckData();
            setGridData([]);
          }
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const ltlOptoins = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
  ]
  const handleFormOnchange = (e) => {
    const { name, value } = e.target;
    // setFormData(prevFormData => ({
    //   ...prevFormData,
    //   [name]: value
    // }));
    setFormData(prevFormData => {
      let updatedFormData = { ...prevFormData, [name]: value };

      // Clear 'ltl_option' when 'truck_load' is set to 'F'
      if (name === 'service_type' && value === 'F') {
        updatedFormData = { ...updatedFormData, ltl_option: null };
      }
      // if (name === 'adr' && value === '1') {
      //   updatedFormData = { ...updatedFormData, driver_number: '1' };
      // }

      if (name === 'truck_material' && (value !== 'CS' && value !== 'FT')) {
        updatedFormData = { ...updatedFormData, extra_truck_specification: [] };
      }
      if (name === 'temperature_control') {
        updatedFormData = { ...updatedFormData, temp1_start: 0, temp1_end: 0, temp2_start: 0, temp2_end: 0 };
      }

      return updatedFormData;
    });
  };

  const handleExtraTruckSpecChange = (e) => {
    const { value, checked } = e.target;

    setFormData(prevFormData => {
      let updatedSpecifications = [...(prevFormData.extra_truck_specification || [])];

      if (checked) {
        updatedSpecifications.push(value); // Add selected option
      } else {
        updatedSpecifications = updatedSpecifications.filter(spec => spec !== value); // Remove unselected option
      }

      return {
        ...prevFormData,
        extra_truck_specification: updatedSpecifications,
      };
    });
  };
  const editOperationalTruck = async (e, data) => {
    console.log('data', data);
    try {
      const res = await withRFSToken.post(OTRUCKDETAIL, { truck_orders_id: data.truck_orders_id })
        .then(function (res) {
          if (res.data.response_code === 200) {
            const innerData = res.data.response_data;
            console.log('data001', innerData);
            setFormData(innerData)
            setModalMode(e);
            setShow(true);
          } else {
            toast.error(res.data.response_msg)
          }
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }

    // const transformedData = {
    //     ...data,
    //     // build_up: data.build_up === "Yes" ? "Y" : "N",
    //     // deck_type: data.deck_type === "Upper Deck" ? "U" : "L"
    // }
    // setFormData(transformedData);
  }

  const addOperationalTruck = async () => {
    const transformData = (formData) => {
      // Clone the original formData to avoid mutation
      const transformedData = { ...formData };

      // Initialize the temperature array
      transformedData.temperature = [];

      // Add temperature ranges based on the value of temperature_control
      if (formData.temperature_control === "TC") {
        transformedData.temperature.push({ temp1: `${formData.temp1Start}-${formData.temp1End}` });
      } else if (formData.temperature_control === "MC") {
        transformedData.temperature.push({ temp1: `${formData.temp1Start}-${formData.temp1End}` });
        transformedData.temperature.push({ temp2: `${formData.temp2Start}-${formData.temp2End}` });
      }

      // Remove unnecessary fields (temp1Start, temp1End, temp2Start, temp2End)
      delete transformedData.temp1Start;
      delete transformedData.temp1End;
      delete transformedData.temp2Start;
      delete transformedData.temp2End;

      return transformedData;
    };
    const transformedData = transformData(formData);


    const dataToSend = {

      ...transformedData,
      bookingtruck_id: selectedRowData?.bookingtruck_id,
      bookingtruck_date_id: selectedRowData?.bookingtruck_date_id,
    }
    // console.log("🚀 ~ addOperationalTruck ~ dataToSend:", dataToSend)
    try {
      const res = await withRFSToken.post(OTRUCKSAVE, dataToSend)
        .then(function (res) {
          if (res.data.response_code === 200) {
            const innerData = res.data.response_data;
            toast.success(res.data.response_msg);
            setTruckList(innerData);
            handleClose();
            fetchTruckData();
            setTimeout(() => {
              setIsLoading(false);
              window.$(gridRef.current).jqxGrid('updatebounddata');
            }, 1);
          } else {
            toast.error(res.data.response_msg)
          }
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState();
  const handleModalClose = () => { setShowModal(false); setModalData(); };
  const [notArea, setNotArea] = useState();
  const handleModalOpen = (area, item) => {
    setNotArea(area);
    if (area === 'T') {
      setModalData(item);
    } else if (area === 'G') {
      // setRowId(item);
    }
    setShowModal(true);

  };
  const handleConfirmation = (confirm) => {
    if (confirm) {
      if (notArea === 'T') {
        deleteTruckList();
      } else if (notArea === 'G') {
        // handleDeleteRow();
      }
      setShowModal(false);
    } else {
      setShowModal(false);
      setModalData();
    }
  };
  const deleteTruckList = async () => {
    // console.log("formdata===>", modalData.pallet_group_id);
    try {
      const res = await withRFSToken.post(OTRUCKREMOVE, { truck_orders_id: modalData.truck_orders_id, bookingtruck_date_id: storedData.bookingtruck_date_id })
        .then(function (res) {
          const innerData = res.data;
          // console.log("🚀 ~ .then ~ innerData:", innerData)
          if (res.data.response_code === 200) {
            toast.success(res.data.response_msg);
            fetchTruckData();
            setTimeout(() => {
              setIsLoading(false);
              window.$(gridRef.current).jqxGrid('updatebounddata');
            }, 1);
          } else {
            toast.error(res.data.response_msg);
          }

        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  };

  const handleOrderTruck = async (info) => {
    // console.log('info', info);
    localStorage.removeItem('OT');
    try {
      const res = await withRFSToken.post(TRUCKORDERDETAILS, { truck_orders_id: info.truck_orders_id })
        .then(function (res) {
          if (res.data.response_code == 200) {
            const innerData = res.data.response_data;
            console.log('innerData', innerData);
            const sendData = {
              ...innerData,
              truck_type: 'B',
              departure_date_time : innerData.departure_date + 'T' + innerData.departure_time,
              arrival_date_time : innerData.arrival_date + 'T' + innerData.arrival_time,
              // bookingTruck_type: 'E',
              // bookingTruck_type: selectedRowData.bookingTruck_type,
              existing_date: selectedRowData.date,
              step: 1
            }
            localStorage.setItem('OT', JSON.stringify(sendData));
            window.location.href = '/OrderTruck'
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  };
  const handleTODetails = (dta) =>{
    localStorage.removeItem('TODetails');
    const storageData = { ...dta, tab: 'manage' };
    localStorage.setItem('TODetails', JSON.stringify(storageData));
    window.location.href = '/TruckOrderDetails'
 
  }

  const handleFinalize = async () => {
    try {
      const res = await withRFSToken.post('booking-schedule-finalize', { bookingtruck_date_id: selectedRowData.bookingtruck_date_id })
        .then(function (res) {
          confirmModalClose();
          if (res.data.response_code == 200) {
            window.location.href = '/BookingtruckDetails'
          } else {
            toast.error(res.data.response_msg);
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  }
  const handleFinalizeConfirm = async () => {
    setConfirmModal(true);
  }

  return (
    <div className=''>
      {/* {console.log('selectedRowData: ', selectedRowData)} */}
      <Header logo_url='/BookingtruckSchedule' />
      <div className="schedule">
        <LeftMenu />
        <div className='main-panel'>
          <Link to={'/BookingtruckDetails/Planning'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
          <div className="mt-3 nestedtabs rounded">
            <div className='d-flex justify-content-between'>
              <div className='viewbook'>
                <h4>Bookingtruck - {selectedRowData?.bookingtruck_no}</h4>
                <p><b>Date :</b> {selectedRowData?.date} <span style={{ marginLeft: '10px', marginRight: '10px', }}><b>Boardpoint :</b> {selectedRowData?.boardpoint} </span> <b>Offpoint :</b> {selectedRowData?.offpoint}</p>
              </div>
              <div className='d-flex align-items-center'>
                <div className='me-3'>
                  <button className="finalize_plan" variant="primary" onClick={handleFinalizeConfirm}>
                    <span>Finalize</span>
                  </button>
                </div>
                {/* <Dropdown>
                  <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                    <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item> Options </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div>
            <Row>
              <Col sm="4">
                <div className='nestedtabs rounded my-3 pl_height'>
                  <div className='d-flex justify-content-between add_pallt'>
                    <h3>Operational Trucks</h3>
                    <Link to='#' onClick={() => handleShow('A')} ><FontAwesomeIcon icon={faPlus} /> Add </Link>
                  </div>
                  <div className='opt_truck_inner'>
                    {truckData?.operational_truck_list?.map((list, index) => (

                      <>
                        <Popup key={index} trigger={
                          <div className={`d-flex justify-content-between operational_truck op_${list.planning_status?.toLowerCase().replace(/\s+/g, '_')}`}>  {/* offer_bg */}
                            <div className='op_left'>
                              <h3>{list.truck_no}</h3>
                              <span>#pos {list.assigned_position}/{list.total_position}</span>
                            </div>
                            <div className={`op_middle`}>
                              <p>{list.planning_status}</p>
                            </div>
                            <div className='op_right'>
                              {list.planning_status === 'Draft' && (<div><Link to='#' onClick={() => editOperationalTruck('E', list)}><img src={edit} /> </Link> <Link to='#' onClick={() => handleModalOpen('T', list)}> <img src={Trash} /></Link></div>)}
                              {list.planning_status === 'Draft' && <div className='ra_order'> <Link to='#' onClick={() => handleOrderTruck(list)}> Order </Link></div>}
                              {list.planning_status !== 'Draft' && <div className='ra_order'>  <Link to='#' onClick={() => handleTODetails(list)}> <img src={View} /></Link> </div>}
                            </div>
                          </div>
                        } position="right top" on={['hover', 'focus']}>
                          <div className="view-truck-details">
                            <Card className="mb-3 shadow-sm border-0">
                              <Card.Body>
                                <h4 className="mb-1"><span>{list.details.truck_no || '-'}</span></h4>
                                {/* {palletList?.map((item, index) => ( */}
                                  <div className='hovrbar'>
                                    <p>Capacity Utilization</p>
                                    <div className='prbar w-100'>
                                      <div className={
                                        list.total_capacity_utilization == 0
                                          ? 'bg-gray'
                                          : (list.total_capacity_utilization > 0 && list.total_capacity_utilization <= 50)
                                            ? 'bg-red'
                                            : (list.total_capacity_utilization > 50 && list.total_capacity_utilization <= 75)
                                              ? 'bg-orange'
                                              : 'bg-green'
                                      }>
                                        <div className="progress" style={{ position: 'relative' }}>
                                          <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: `${list.total_capacity_utilization}%` }} aria-valuenow={list.total_capacity_utilization} aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span className='bar_text'>{list.total_capacity_utilization || 0}%</span>
                                      </div>
                                    </div>
                                  </div>
                                {/* ))} */}

                                <p className="mb-1 d-flex justify-content-between">
                                  <span>
                                    <span>Departure Date/Time:</span><br />
                                    <span>{list.departure_date_time || '-'}</span>
                                  </span>
                                  <span>
                                    <span>Arrival Date/Time:</span><br />
                                    <span>{list.arrival_date_time || '-'}</span>
                                  </span>
                                </p>
                                <p className="mb-1 d-flex justify-content-between">
                                  <span>
                                    <span>Truck Load:</span><br />
                                    <span>
                                      {list.details.truck_load_type === 'F'
                                        ? 'FTL'
                                        : list.details.truck_load_type === 'L'
                                          ? `LTL (${list.details.service_type_value || 0} Positions)`
                                          : '-'
                                      }
                                    </span>
                                  </span>
                                  <span><span>Number of Drivers: </span><br /><span>{list.details.number_of_drivers || '-'}</span></span>

                                </p>
                                <hr />
                                <p className="mb-1">
                                  <span><span>ADR Required:</span><br /><span>{list.details.adr == 1 ? 'Yes' : 'No'}</span></span>
                                </p>
                                <p className="mb-1">
                                  <span>
                                    <Row>
                                      <Col sm="12">
                                        {list.details.temperature_control === 'N' && <p className="mb-1"><span><span>Temperature Controlled:</span><br /><span> No</span></span></p>}
                                        {list.details.temperature_control === 'TC' && (
                                          <p className="mb-1">
                                            <span>
                                              <span>Temperature Controlled:</span><br /> <span>{list.details.temp1_start}°C – {list.details.temp1_end}°C</span>
                                            </span>
                                          </p>
                                        )}
                                        {list.details.temperature_control === 'MC' && (
                                          <>
                                            <p className="mb-1">
                                              <span>
                                                <span>Multi-Temperature:</span><br />
                                                <span>
                                                  <ul>
                                                    <li>Range 1: {list.details.temp1_start}°C – {list.details.temp1_end}°C</li>
                                                    <li>Range 2: {list.details.temp2_start}°C – {list.details.temp2_end}°C</li>
                                                  </ul>
                                                </span>
                                              </span>
                                            </p>

                                          </>
                                        )}

                                      </Col>
                                    </Row>
                                  </span>
                                </p>

                                <p className="mb-1 d-flex justify-content-between">
                                  <span>
                                    <span>Truck Material:</span><br />
                                    <span>
                                      {' '}
                                      {list.details.truck_material === 'HC'
                                        ? 'Hard Cover'
                                        : list.details.truck_material === 'CS'
                                          ? 'Curtain Slider'
                                          : list.details.truck_material === 'FT'
                                            ? 'Flatbed Trailer'
                                            : '-'}
                                    </span>
                                  </span>
                                  <span>
                                    {list.details.extra_truck_specification &&
                                      list.details.extra_truck_specification !== "[]" &&
                                      list.details.extra_truck_specification.length > 0 && (
                                        <>
                                          <span>Extra Truck Options:</span><br />
                                          <ul className="mb-2 ps-0">
                                            {
                                              Array.isArray(list.details.extra_truck_specification)
                                                ? list.details.extra_truck_specification.map((opt, i) => (
                                                  <li key={i}>{opt}</li>
                                                ))
                                                : JSON.parse(list.details.extra_truck_specification || '[]').map((opt, i) => (
                                                  <li key={i}>{opt}</li>
                                                ))
                                            }
                                          </ul>
                                        </>
                                      )}
                                  </span>
                                </p>

                                <hr />

                                <Row>
                                  <Col sm="12">
                                    <p className="mb-1 d-flex justify-content-between align-items-center">
                                      <span>
                                        <span>Min. Truck Height:</span><br />
                                        <span>{list.details.truck_height || '-'} cm</span>
                                      </span>
                                      <span><span>Rollerbed:</span> <br /><span>{list.details.rollerbed === 'Y' ? 'Yes' : 'No'}</span></span>
                                    </p>

                                    <p className="mb-1"><span><span>Remarks: </span><br /><span>{list.details.remarks || '-'}</span></span> </p>
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>

                          </div>
                        </Popup>
                      </>
                    ))}
                  </div>
                </div>
              </Col>
              <Col sm="4" >
                <div >
                  <div className='nestedtabs rounded my-3 pl_height'>
                    <div className="new_chart">
                      <h3>Truck Capacity Utilization </h3>
                      <p>Capacity used for Operational Trucks</p>
                    </div>
                    <ApexCharts
                      options={statusOptions}
                      series={statusSeries}
                      type="bar"
                      height={'88%'}
                    />
                  </div>
                </div>
              </Col>
              <Col sm="4" >
                <div className='nestedtabs rounded my-3 pl_height'>
                  <Table className='optional_table'>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Total</th>
                        <th>Available Positions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Trucks</td>
                        <td>{truckData?.planning_information.trucks_total}</td>
                        <td>{truckData?.planning_information.trucks_available_positions}</td>
                      </tr>
                      <tr>
                        <th></th>
                        <th>Planned</th>
                        <th>Unplanned</th>
                      </tr>
                      <tr>
                        <td>Positions</td>
                        <td>{truckData?.planning_information.positions_planned}</td>
                        <td>{truckData?.planning_information.positions_unplanned}</td>
                      </tr>
                      <tr>
                        <td>Pallets</td>
                        <td>{truckData?.planning_information.pallets_planned}</td>
                        <td>{truckData?.planning_information.pallets_unplanned}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className='nestedtabs rounded '>
                  {!isLoading && <div ref={gridRef} className='ovgrid'></div>}
                  {/* <div ref={gridRef} className='ovgrid'></div> */}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered className='addfrom book_sdl op_truck' size='md'>
        <Modal.Header closeButton>
          <Modal.Title>{modalMode === 'E' ? 'Edit' : 'Add'} Operational truck </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-2'>
            <Form.Label>Operational Truck <span>*</span></Form.Label>
            <Form.Control name='truck_no' value={formData.truck_no} onChange={handleFormOnchange} placeholder='Truck Number' />
          </Form.Group>
          {/* <Form.Group as={Row} className='mb-2'>
            <Form.Label>Date and Time</Form.Label>
            <Col sm="6">
              <Form.Control name='departure_date' type='date' value={formData.departure_date} onChange={handleFormOnchange} placeholder='Date' />
            </Col>
            <Col sm="6">
              <Form.Control name='departure_time' type='time' value={formData.departure_time} onChange={handleFormOnchange} placeholder='Time' />
            </Col>
          </Form.Group> */}
          <Form.Group as={Row} className='mb-2'>
              <Col sm="6">
                  <Form.Label>Departure Date / Time <span>*</span></Form.Label>
                  <Form.Control type="datetime-local" name='departure_date_time' value={formData.departure_date_time} onChange={handleFormOnchange} />
              </Col>
              <Col sm="6">
                  <Form.Label>Arrival Date / Time <span>*</span></Form.Label>
                  <Form.Control type="datetime-local" name='arrival_date_time' value={formData.arrival_date_time} onChange={handleFormOnchange} />
              </Col>
              {/* <Col sm="6">
                  <Form.Label>Departure Time</Form.Label>
                  <Form.Control type="time" name='departure_time' value={formData.departure_time} onChange={handleFormOnchange} />
              </Col> */}
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label>Truck Load <span>*</span></Form.Label>
            <div className='d-flex'>
              <div>
                <Form.Check
                  inline
                  label="FTL"
                  name="service_type"
                  type='radio'
                  id='ftl'
                  value="F"
                  checked={formData?.service_type === 'F'}
                  onChange={handleFormOnchange}
                />
              </div>
              <div>
                <Form.Check
                  inline
                  label="LTL"
                  name="service_type"
                  type='radio'
                  id='ltl'
                  value="L"
                  checked={formData?.service_type === 'L'}
                  onChange={handleFormOnchange}
                />
              </div>
              <div className='ltl_drop'>
                {formData?.service_type === 'L' &&
                  <Select
                    options={ltlOptoins}
                    onChange={(selected) => {
                      const updatedData = { ...formData, service_type_value: selected.value };
                      setFormData(updatedData);
                    }}
                    placeholder="Amount of Positions"
                    className='autoslct rfslct'
                    name="service_type_value"
                    // isDisabled={boardPointAddress.length > 0 ? false : true}
                    value={ltlOptoins.find(option => option.value === String(formData.service_type_value))}
                  />
                }
              </div>
            </div>
          </Form.Group>
          <Form.Group as={Row}>
            <Col sm='6'>
              <Form.Label>Number of Drivers <span>*</span></Form.Label>
              <div className='num_drive'>
                <Form.Check
                  inline
                  label="1"
                  name="driver_number"
                  type='radio'
                  id='dn_1'
                  value="1"
                  checked={formData.driver_number == 1}
                  onChange={handleFormOnchange}
                />
                <Form.Check
                  inline
                  label="2"
                  name="driver_number"
                  type='radio'
                  id='dn_2'
                  value="2"
                  checked={formData.driver_number == 2}
                  onChange={handleFormOnchange}
                />
              </div>
            </Col>
            <Col sm='6'>
              <Form.Label>ADR Required <span>*</span></Form.Label>
              <div>
                <Form.Check
                  inline
                  label="Yes"
                  name="adr"
                  type='radio'
                  id='adr_1'
                  value="1"
                  checked={formData.adr == 1}
                  onChange={handleFormOnchange}
                />
                <Form.Check
                  inline
                  label="No"
                  name="adr"
                  type='radio'
                  id='adr_0'
                  value="0"
                  checked={formData.adr == 0}
                  onChange={handleFormOnchange}
                />
              </div>
            </Col>
          </Form.Group>
          <hr />
          <Form.Group as={Row}>
            <Form.Label>Temperature Control <span>*</span></Form.Label>
            <div>
              <Form.Check
                inline
                label="No"
                name="temperature_control"
                type='radio'
                id='N'
                value="N"
                checked={formData.temperature_control === 'N'}
                onChange={handleFormOnchange}
              />
              <Form.Check
                inline
                label="Temperature"
                name="temperature_control"
                type='radio'
                id='TC'
                value="TC"
                checked={formData.temperature_control === 'TC'}
                onChange={handleFormOnchange}
              />
              <Form.Check
                inline
                label="Multi-Temperature "
                name="temperature_control"
                type='radio'
                id='MC'
                value="MC"
                checked={formData.temperature_control === 'MC'}
                onChange={handleFormOnchange}
              />
              {formData.temperature_control === 'TC' &&

                <div className="multi_temp">
                  <h4>Temperature Range</h4>
                  <div className="d-flex">
                    <InputGroup className="ra_temprang">
                      <Form.Control
                        type="number"
                        min={-15}
                        max={formData.temp1_end}
                        value={formData.temp1_start}
                        onChange={(e) => tempChange('temp1_start', e)}
                      />
                      <InputGroup.Text>°C</InputGroup.Text>
                      <div>
                        <div className="d-flex flex-column">
                          <Button variant="link" onClick={() => handleIncrease('temp1_start', 30)}>
                            <FontAwesomeIcon icon={faChevronUp} />
                          </Button>
                          <Button variant="link" onClick={() => handleDecrease('temp1_start', -15)}>
                            <FontAwesomeIcon icon={faChevronDown} />
                          </Button>
                        </div>
                      </div>
                    </InputGroup>
                    <span className="rang_gap">-</span>
                    <InputGroup className="ra_temprang">
                      <Form.Control
                        type="number"
                        min={formData.temp1_start}
                        max={30}
                        value={formData.temp1_end}
                        onChange={(e) => tempChange('temp1_end', e)}
                      />
                      <InputGroup.Text>°C</InputGroup.Text>
                      <div>
                        <div className="d-flex flex-column">
                          <Button variant="link" onClick={() => handleIncrease('temp1_end', 30)}>
                            <FontAwesomeIcon icon={faChevronUp} />
                          </Button>
                          <Button variant="link" onClick={() => handleDecrease('temp1_end', -15)}>
                            <FontAwesomeIcon icon={faChevronDown} />
                          </Button>
                        </div>
                      </div>
                    </InputGroup>
                  </div>
                </div>
              }
              {formData.temperature_control === 'MC' &&
                <div className='multi_temp'>
                  <ul>
                    <li>
                      <h4>Temperature Range 1</h4>
                      <div className="d-flex">
                        <InputGroup className="ra_temprang">
                          <Form.Control
                            type="number"
                            min={-15}
                            max={formData.temp1_end}
                            value={formData.temp1_start}
                            onChange={(e) => tempChange('temp1_start', e)}
                          />
                          <InputGroup.Text>°C</InputGroup.Text>
                          <div>
                            <div className="d-flex flex-column">
                              <Button variant="link" onClick={() => handleIncrease('temp1_start', 30)}>
                                <FontAwesomeIcon icon={faChevronUp} />
                              </Button>
                              <Button variant="link" onClick={() => handleDecrease('temp1_start', -15)}>
                                <FontAwesomeIcon icon={faChevronDown} />
                              </Button>
                            </div>
                          </div>
                        </InputGroup>
                        <span className="rang_gap">-</span>
                        <InputGroup className="ra_temprang">
                          <Form.Control
                            type="number"
                            min={formData.temp1_start}
                            max={30}
                            value={formData.temp1_end}
                            onChange={(e) => tempChange('temp1_end', e)}
                          />
                          <InputGroup.Text>°C</InputGroup.Text>
                          <div>
                            <div className="d-flex flex-column">
                              <Button variant="link" onClick={() => handleIncrease('temp1_end', 30)}>
                                <FontAwesomeIcon icon={faChevronUp} />
                              </Button>
                              <Button variant="link" onClick={() => handleDecrease('temp1_end', -15)}>
                                <FontAwesomeIcon icon={faChevronDown} />
                              </Button>
                            </div>
                          </div>
                        </InputGroup>
                      </div>
                    </li>
                    <li>
                      <h4>Temperature Range 2</h4>
                      <div className="d-flex">
                        <InputGroup className="ra_temprang">
                          <Form.Control
                            type="number"
                            min={-15}
                            max={formData.temp2_end}
                            value={formData.temp2_start}
                            onChange={(e) => tempChange('temp2_start', e)}
                          />
                          <InputGroup.Text>°C</InputGroup.Text>
                          <div>
                            <div className="d-flex flex-column">
                              <Button variant="link" onClick={() => handleIncrease('temp2_start', 30)}>
                                <FontAwesomeIcon icon={faChevronUp} />
                              </Button>
                              <Button variant="link" onClick={() => handleDecrease('temp2_start', -15)}>
                                <FontAwesomeIcon icon={faChevronDown} />
                              </Button>
                            </div>
                          </div>
                        </InputGroup>
                        <span className="rang_gap">-</span>
                        <InputGroup className="ra_temprang">
                          <Form.Control
                            type="number"
                            min={formData.temp2_start}
                            max={30}
                            value={formData.temp2_end}
                            onChange={(e) => tempChange('temp2_end', e)}
                          />
                          <InputGroup.Text>°C</InputGroup.Text>
                          <div>
                            <div className="d-flex flex-column">
                              <Button variant="link" onClick={() => handleIncrease('temp2_end', 30)}>
                                <FontAwesomeIcon icon={faChevronUp} />
                              </Button>
                              <Button variant="link" onClick={() => handleDecrease('temp2_end', -15)}>
                                <FontAwesomeIcon icon={faChevronDown} />
                              </Button>
                            </div>
                          </div>
                        </InputGroup>
                      </div>
                    </li>
                  </ul>
                </div>
              }
            </div>
          </Form.Group>
          <hr />
          <Form.Group as={Row} className='mb-2'>
            <Form.Label>Truck Material <span>*</span></Form.Label>
            <div className="mb-2">
              <Form.Check
                inline
                label="Hard Cover"
                name="truck_material"
                type='radio'
                id='HC'
                value="HC"
                checked={formData.truck_material === 'HC'}
                onChange={handleFormOnchange}
              />
              <Form.Check
                inline
                label="Curtain Slider"
                name="truck_material"
                type='radio'
                id='CS'
                value="CS"
                checked={formData.truck_material === 'CS'}
                onChange={handleFormOnchange}
              />
              <Form.Check
                inline
                label="Flatbed Trailer"
                name="truck_material"
                type='radio'
                id='FT'
                value="FT"
                checked={formData.truck_material === 'FT'}
                onChange={handleFormOnchange}
              />
              {formData.truck_material === 'CS' &&
                <div className='multi_temp'>
                  <h4>Extra Truck Option </h4>
                  <ul>
                    <li>
                      <Form.Check
                        inline
                        label="Extra Wide Truck"
                        name="extra_truck_specification"
                        value="Extra Wide Truck"
                        onChange={handleExtraTruckSpecChange}
                        checked={formData.extra_truck_specification?.includes("Extra Wide Truck")}
                      />
                    </li>
                    <li>
                      <Form.Check
                        inline
                        label="Soft Top"
                        name="extra_truck_specification"
                        value="Soft Top"
                        onChange={handleExtraTruckSpecChange}
                        checked={formData.extra_truck_specification?.includes("Soft Top")}
                      />
                    </li>
                    <li>
                      <Form.Check
                        inline
                        label="Reinforced Curtain"
                        name="extra_truck_specification"
                        value="Reinforced Curtain"
                        onChange={handleExtraTruckSpecChange}
                        checked={formData.extra_truck_specification?.includes("Reinforced Curtain")}
                      />
                    </li>
                    <li>
                      <Form.Check
                        inline
                        label="Adjustable Roof"
                        name="extra_truck_specification"
                        value="Adjustable Roof"
                        onChange={handleExtraTruckSpecChange}
                        checked={formData.extra_truck_specification?.includes("Adjustable Roof")}
                      />
                    </li>
                    <li>
                      <Form.Check
                        inline
                        label="Exceptional Transport"
                        name="extra_truck_specification"
                        value="Exceptional Transport"
                        onChange={handleExtraTruckSpecChange}
                        checked={formData.extra_truck_specification?.includes("Exceptional Transport")}
                      />
                    </li>
                    <li>
                      <Form.Check
                        inline
                        label="Side Loading Capbility"
                        name="extra_truck_specification"
                        value="Side Loading Capbility"
                        onChange={handleExtraTruckSpecChange}
                        checked={formData.extra_truck_specification?.includes("Side Loading Capbility")}
                      />
                    </li>
                  </ul>
                </div>
              }
              {formData.truck_material === 'FT' &&
                <div className='multi_temp'>
                  <h4>Extra Truck Option</h4>
                  <ul>
                    <li>
                      <Form.Check
                        inline
                        label="Extendable Length"
                        name="extra_truck_specification"
                        value="Extendable Length"
                        onChange={handleExtraTruckSpecChange}
                        checked={formData.extra_truck_specification?.includes("Extendable Length")}
                      />
                    </li>
                  </ul>
                </div>
              }
            </div>
          </Form.Group>
          <Form.Group as={Row} className='mb-2'>
            <Col sm='6'>
              <Form.Label>Min. Truck Height (cm) <span>*</span></Form.Label>
              <div className="mb-2">
                <Form.Control
                  name='truck_height'
                  value={formData.truck_height}
                  onChange={handleFormOnchange}
                  placeholder='Min. Truck Height'
                  style={{ height: "32px" }}
                />
              </div>
            </Col>
            <Col sm='6'>
              <Form.Label>Rollerbed <span>*</span></Form.Label>
              <div className="mb-2">
                <Form.Check
                  inline
                  label="Yes"
                  name="rollerbed"
                  type='radio'
                  id='yes'
                  value="Y"
                  checked={formData.rollerbed === 'Y'}
                  onChange={handleFormOnchange}
                />
                <Form.Check
                  inline
                  label="No"
                  name="rollerbed"
                  type='radio'
                  id='no'
                  value="N"
                  checked={formData.rollerbed === 'N'}
                  onChange={handleFormOnchange}
                />
              </div>
            </Col>
          </Form.Group>
          <hr />
          <Form.Group className='mb-2'>
            <Form.Label>Remarks</Form.Label>
            <Form.Control as="textarea" rows={3} name='remarks' value={formData.remarks} onChange={handleFormOnchange} placeholder='' style={{ height: 'auto' }} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={addOperationalTruck} >
            {modalMode === 'E' ? 'Update' : 'Add'} Operational truck
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>All changes will be destroyed.</h3>
          <p>If you proceed with the change, all data in this section will be removed.
            Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => handleConfirmation(false)}>
              No
            </Button>
            <Button variant="primary" onClick={() => handleConfirmation(true)}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={confirmModal} onHide={confirmModalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Finalize Planning</h3>
          <p>
            Are you sure you want to finalize the planning? After finalization, truck load plan will be shared with the handler and trucker.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={confirmModalClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleFinalize}>
              Finalize
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default TruckPlanning;